<template>
  <fieldset>
    <SignupLegend :title="`Directors of ${formData.name}`"/>
    <p>
      Legal regulations require us to <a href="https://getaio.co.uk/kyb" target="_blank">check the identity</a> of {{formData.activeOfficers.length >= 2 ? 'two directors' :
      'the director'}} of {{formData.name}}.<br>
      For this we need their <b>current home address</b> and <b>DOB</b>. If you are unsure, you can select 'ask me
      later'.
      <span v-if="formData.activeOfficers.length < 2"><br>If {{formData.name}} has a second director, please add their details as well.</span>
    </p>
    <RequiredInfoPopup/>
    <hr>
    <div class="director" v-for="(director, i) in formData.companyDirectors" :key="i">
      <hr v-if="i > 0">
      <div class="row">
        <div class="col"><h4 class="edit">{{nth(i)}} Director</h4></div>
      </div>
      <div class="row" v-if="formData.activeOfficers.length >= 3">
        <div class="col form-group">
          <select class="form-control" @change="onChange(i)" v-model="formData.selectedDirector[i]">
            <option value="" disabled selected>Please select {{nth(i)}} director</option>
            <option v-for="(officer, j) in formData.activeOfficers" :value="officer" :disabled="whenSelected(officer)" :key="i+','+j">
              {{officer.name}}
            </option>
          </select>
        </div>
      </div>
      <BasePersonInput v-model="formData.companyDirectors[i]"/>
    </div>
    <button type="button" class="btn btn-outline-primary d-block mx-auto" @click="toggleDirector"
            v-if="formData.companyDirectors.length <= 2">
      <span class="fas fa-plus-circle"></span> {{action}} 2nd director
    </button>
    <hr>
    <BaseNaviButtons :beforeSubmit="setDirectors" :toSubmit="formData"/>
  </fieldset>
</template>

<script>
  import BaseNaviButtons from '@/components/BaseNaviButtons'
  import BasePersonInput from '@/components/BasePersonInput'
  import helperMixin from '@/utils/helperMixin'
  import Person from '@/utils/Person'
  import RequiredInfoPopup from '@/components/RequiredInfoPopup'
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      BaseNaviButtons,
      BasePersonInput,
      RequiredInfoPopup,
      SignupLegend
    },
    computed: {
      action () {
        return this.formData.companyDirectors.length <= 1 ? 'add' : 'remove'
      }
    },
    created () {
      switch (this.formData.activeOfficers.length) {
        case 0:
          break
        case 1:
        case 2:
          this.formData.companyDirectors = this.formData.activeOfficers
          break
        default:
          if (this.formData.companyDirectors.length <= 1) this.formData.companyDirectors.push(new Person())
      }
    },
    methods: {
      onChange (i) {
        this.formData.companyDirectors[i] = this.formData.selectedDirector[i]
      },
      setDirectors () {
        this.formData.directors = this.formData.companyDirectors.map(d => Person.stringify(d))
        return Promise.resolve()
      },
      toggleDirector () {
        if (this.action === 'add') this.formData.companyDirectors.push(new Person())
        else this.formData.companyDirectors.pop()
      },
      whenSelected (officer) {
        return this.formData.companyDirectors.includes(officer)
      }
    },
    mixins: [helperMixin],
    props: {
      formData: Object
    }
  }
</script>

<style lang="scss" scoped>
</style>
